module.exports = __webpack_public_path__ + "static/media/medl.cc800378.png";